import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { AddressFieldsNLDefault } from './AddressFieldsNLDefault';
import { AddressFieldsNLWithCard } from './AddressFieldsNLWithCard';
export const AddressFieldsNL = (_a) => {
    var { showAddressCard } = _a, props = __rest(_a, ["showAddressCard"]);
    return showAddressCard ? _jsx(AddressFieldsNLWithCard, Object.assign({}, props)) : _jsx(AddressFieldsNLDefault, Object.assign({}, props));
};
